export interface RootDestinationInput {
  hasSession: boolean;
  activeSurface: string | null;
  isIDE: boolean;
}

/**
 * Surfaces the `/` dispatcher will auto-resolve to for a signed-in user.
 * Deliberately excludes `agent` and `todos` — those are reachable via the rail
 * but `/` falls back to `dashboard` for them (keeps `/` stable across builds).
 */
const ALLOWED_SURFACES = ['dashboard', 'documents', 'work-items', 'members', 'settings'];

/**
 * Decide where the `/` route should redirect.
 *
 * Signed-out: the plain web app shows the marketing landing page; the IDE
 * sends users straight to sign-in (the marketing page is never shown there).
 * Signed-in: the user's last-active surface, or Dashboard as a safe fallback.
 */
export function rootDestination(input: RootDestinationInput): string {
  if (!input.hasSession) {
    return input.isIDE ? '/sign-in' : '/landing';
  }
  const surface = input.activeSurface ?? 'dashboard';
  return ALLOWED_SURFACES.includes(surface) ? `/${surface}` : '/dashboard';
}
